<template>
  <div class="app-category-filter-wrapper custom-wrapper">

    <div class="filter-wrapper">
      <el-form
        label-position="right"
        label-width="100px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item label="父分类 ID" prop="father_category_id">
          <el-input
            v-model="filterForm.father_category_id"
            placeholder="请输入父分类 ID"
            type="number"
            @keyup.enter.native="onFilterSubmit" />
        </el-form-item>

      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="onFilterReset">重置</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'AppCategoryFilter',
  data () {
    return {
      filterForm: {
        father_category_id: ''
      }
    }
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    onFilterSubmit () {
      this.setPage(1)
      if (this.filterForm.father_category_id === '') {
        this.filterForm = {}
      }
      this.setFilters(this.filterForm)
      this.$emit('filter')
    },
    onFilterReset () {
      this.$refs['filterForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/sass/base";

.app-category-filter-wrapper {

  .filter-wrapper .el-form-item {
    width: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/AppCategoryFilter.vue